import { useEffect } from 'react';

import $ from 'jquery';

function useTitle(title) {
    useEffect(() => {
        document.title = title;
    }, [title]);
}


const HOST = process.env.REACT_APP_HOST;

const API_ROUTES = {
    'IS_LOGGED': HOST + '/api/house/isLogged',
    'LOGIN': HOST + '/api/login',
    'DEVICES_GET_DATA': HOST + '/api/house/devicesData',
    'DEVICES_GET_PROGS': HOST + '/api/house/devicesProgs',
    'DEVICES_CHANGE_STATE': HOST + '/api/house/changeState',
    'DEVICES_METRICS': HOST + '/api/house/deviceMetrics',
    'PROG_DISABLE_ENABLE': HOST + '/api/house/disableEnableProg',
    'PROG_SAVE': HOST + '/api/house/saveProg',
    'PROG_CANCEL': HOST + '/api/house/cancelProg',
    'VR_DATA': HOST + '/api/house/vrData',
    'VR_OPERATION': HOST + '/api/house/vrOperation',
    'ELEC_GET_CONSO': HOST + '/api/house/elecConso',
    'ELEC_SEARCH_ADR': HOST + '/api/house/elecSearchAdresse',
}

const TRANS_SS_MODES = {
    'boost': 'Boost',
    'comfort': 'Confort',
    'eco': 'Eco',
    'frostprotection': 'Arrêt/Antigel',
}

function addFlashMessage(level, message, canClose) {
    if (level === 'error') {
        level = 'danger';
    }
    let template = '<div class="alert alert-' + level + '">';
    if (canClose === true) {
        template += '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
    }
    template += message;
    template += '</div>';
    $('#flashMessages').append(template);
}

function setFlashMessage(level, message, canClose = true) {
    clearFlashMessages();
    addFlashMessage(level, message, canClose);
}

function clearFlashMessages() {
    $('#flashMessages').html('');
}

function userIsLogged() {
    return new Promise((resolve, reject) => {
        fetch(API_ROUTES.IS_LOGGED, {
            method: 'GET',
        }).then(response => response.json()).then((data) => {
            if (data && data.isLogged === true) {
                resolve(true)
            } else {
                resolve(false)
            }
        }).catch((error) => {
            console.error('Error:', error)
            resolve(false)
        })
    })
}

// TODO : improve this hardcoded values
const DEVICES_LIST = [
    { name: 'R_SALON', label: 'SALON' },
    { name: 'R_BUREAU', label: 'BUREAU' },
    { name: 'R_CH-BUREAU', label: 'CH-BUREAU' },
    { name: 'R_CH-LUCIE', label: 'CH-LUCIE' },
    { name: 'R_CH-PARENTALE', label: 'CH-PARENTALE' },
    { name: 'O_SS', label: 'Sèche serviettes' },
]


export {
    useTitle,
    API_ROUTES,
    setFlashMessage,
    clearFlashMessages,
    userIsLogged, 
    TRANS_SS_MODES,
    DEVICES_LIST
}